import { Card, CardContent } from "@repo/ui";

function TeamInfoCard({ team }) {
  return (
    <div className="flex-1">
      <Card>
        <CardContent className="p-4">
          <div className="p-2">
            <label className="font-medium leading-none text-sm">
              {`Employee Id: ${team.employeeId}`}
            </label>
          </div>
          <div className="p-2">
            <label className="font-medium leading-none text-sm">
              {`Name: ${team.name}`}
            </label>
          </div>
          <div className="p-2">
            <label className="font-medium leading-none text-sm">
              {`Role: ${team.role}`}
            </label>
          </div>
          <div className="p-2">
            <label className="font-medium leading-none text-sm">
              {`Nationality: ${team.nationality}`}
            </label>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default TeamInfoCard;
